import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RequestsHttpClient } from '@omnea-app/requests/requestsHttpClient'
import { PauseReasonsQueryKey } from './useGetPauseReasons'

export const useDeletePauseReason = () => {
  const { getToken } = useAuthenticatedUser()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ reasonId }: { reasonId: string }) => {
      const apiClient = new RequestsHttpClient({ authorization: await getToken() })

      const { data, error } = await apiClient.POST('/pause-reasons/{reasonId}/delete', {
        params: { path: { reasonId } },
        body: {},
      })

      throwIfApiError(error)

      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: PauseReasonsQueryKey }),
  })
}
